module.exports = __webpack_public_path__ + "media/images/gallery/constellations/canis_minor/cmi_lines-1a3b826d778f37359e9074cf0e951504.gif";